import { useEffect, useState } from 'react';

const PHONE = '(max-width: 639px)';

const canMatch = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

/**
 * True below 640px, where the Students pages swap a row of controls for a bottom sheet and a table
 * for stacked cards. Without matchMedia (a test DOM, a very old browser) it is the laptop layout.
 */
export default function useIsPhone() {
  const [phone, setPhone] = useState(() => (canMatch() ? window.matchMedia(PHONE).matches : false));

  useEffect(() => {
    if (!canMatch()) return undefined;
    const list = window.matchMedia(PHONE);
    const sync = () => setPhone(list.matches);
    sync();
    if (list.addEventListener) {
      list.addEventListener('change', sync);
      return () => list.removeEventListener('change', sync);
    }
    list.addListener(sync);
    return () => list.removeListener(sync);
  }, []);

  return phone;
}
